<template>
  <span
    class="flex relative z-40 items-center select-none bg-white p-2 rounded-lg border cursor-pointer"
    @mouseenter="dataIsHovered = true"
    @mouseleave="dataIsHovered = false"
    @click="dataShowFlyout = !dataShowFlyout"
    >
    <div class="flex items-center gap-3">
      <div class="w-6 min-h-4">
        <ui-flag v-if="locale == 'ru'" iso="uk" class="rounded"/>
        <ui-flag v-else :iso="locale" class="rounded"/>
      </div>
      <i class="fas fa-angle-down text-[#111724]"/>
    </div>

    <div v-show="dataShowFlyout" class="ui-flyout -mt-10 !-right-2 !min-w-0">
      <div class="ui-rounded">
        <NuxtLink
          v-for="(l) in availableLocales"
          :key="l.code"
          class="border-b -mx-1"
          :to="switchLocalePath(l.code)"
          @click="methodLanguageSelected(l)"
          >
          <div class="flex gap-2 items-center justify-between py-px">
            <div v-text="l.code.toUpperCase()" />
            <div class="w-8">
              <ui-flag :iso="l.code" class="rounded"/>
            </div>
          </div>
        </NuxtLink>
      </div>
    </div>
  </span>
</template>

<script setup>
const { locale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()

const dataShowFlyout = ref(false)
const dataIsHovered = ref(false)
const dataLastHoverStart = ref(0)

const availableLocales = computed(() => {
  return locales.value.filter(i => i.code !== locale.value && i.code !== 'ru')
})

const methodLanguageSelected = (l) => {
  setting('locale', l.code)
  dataShowFlyout.value = false;
  switchLocalePath(l.code).toLowerCase()
}

watch(dataIsHovered, (val) => {
  dataLastHoverStart.value = Date.now()

  if (!val) {
    setTimeout(() => {
      const start = dataLastHoverStart.value
      if (start == dataLastHoverStart.value && !dataIsHovered.value) {
        dataShowFlyout.value = false
      }
    }, 1000)
  }
})

watch(useRoute(), () => {
  dataShowFlyout.value = false
})
</script>
